import styled from '@emotion/styled';

import {
  Grid,
  List,
  ListItemText as MuiListItemText,
  ListItemButtonProps as MuiListItemButtonProps,
  ListItemButton as MuiListItemButton,
} from '@mui/material';

interface ListItemButtonProps extends MuiListItemButtonProps {
  href?: string;
}

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(0.25)} ${(props) => props.theme.spacing(4)};
  background: ${(props) => props.theme.footer.background};
  position: relative;
`;

type ListItemButtonLinkProps = ListItemButtonProps & { target: string };

const ListItemButton = styled(MuiListItemButton)<ListItemButtonLinkProps>`
  display: inline-block;
  width: auto;
  padding-left: ${(props) => props.theme.spacing(2)};
  padding-right: ${(props) => props.theme.spacing(2)};

  &,
  &:hover,
  &:active {
    color: #ff0000;
  }
`;

const ListItemText = styled(MuiListItemText)`
  span {
    color: ${(props) => props.theme.footer.color};
  }
`;

function Footer() {
  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Grid sx={{ display: { xs: 'none', md: 'block' } }} container item xs={12} md={6}>
          <List>
            <ListItemButton component="a" href="https://www.getskimmer.com/home/terms" target="_blank">
              <ListItemText primary="Terms of Use" />
            </ListItemButton>
            <ListItemButton component="a" href="https://www.getskimmer.com/home/privacy" target="_blank">
              <ListItemText primary="Privacy Policy" />
            </ListItemButton>
          </List>
        </Grid>
        <Grid container item xs={12} md={6} justifyContent="flex-end">
          <List>
            <ListItemButton component="a" href="https://www.getskimmer.com" target="_blank">
              <ListItemText primary={`Copyright Skimmer, Inc. © ${new Date().getFullYear()}`} />
            </ListItemButton>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default Footer;
